module.exports = __webpack_public_path__ + "img/Element-Overlay-Correct.db7e8750.svg";